import { Box, Flex, Button, Select, Textarea, Spinner, Input, Checkbox, useToast } from '@chakra-ui/react';

import { useParams } from 'react-router-dom';
import React, { useEffect } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import dayjs from 'dayjs';

import DatePicker from 'components/datePicker/DatePicker';
import globals from 'styles/globals.module.css';
import xhr from 'xhr';
import useAuth from 'hooks/useAuth';
import Month from './month';
import SubjectsCantidadesPicker from './SubjectsCantidadesPicker';
import PaymentProgramItem from './PaymentProgramItem';
import { saveMonths } from './useMonthStudent';

export default function FormPagos(props) {
  let params = useParams();
  const { mutate, paymentsData, advisers, setIsOpen } = props;
  const [payments, setPayments] = React.useState([]);
  const [programs, setPrograms] = React.useState([]);
  const [months, setMonths] = React.useState([]);
  const [selectedMonths, setSelectedMonths] = React.useState([]);
  const [subjects, setSubjects] = React.useState([]);
  const [checked, setChecked] = React.useState(false);
  const [subjectEnrollments, setSubjectsEnrollments] = React.useState([]);
  const [otherPayments, setOtherPayments] = React.useState([]);
  const [concept, setConcept] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [currentProgram, setCurrentProgram] = React.useState('');
  const [currentProgramType, setCurrentProgramType] = React.useState({});
  const [currentEnrollment, setCurrentEnrollment] = React.useState();
  const [fetchingEnrollment, setFetchingEnrollment] = React.useState(true);
  const [currencies, setCurrencies] = React.useState([]);
  const [affiliates, setAffiliates] = React.useState([]);
  const [monthsError, setMonthsError] = React.useState(false);
  // Programas por materias: cantidades del pago (reemplaza la grilla de meses).
  const [cantidadesState, setCantidadesState] = React.useState(null);
  const [cantidadesError, setCantidadesError] = React.useState(false);
  // Multi-programa: cada ítem tiene su propio programa/matrícula/picker.
  // El primero es la fuente de verdad "current" para mantener compat con la lógica actual.
  const [programItems, setProgramItems] = React.useState([{ programId: null, enrollment: null, cantidadesState: null, monthState: null }]);
  const setItem = React.useCallback((idx, patch) => {
    setProgramItems((prev) => prev.map((it, i) => i === idx ? { ...it, ...patch } : it));
  }, []);
  const addItem = React.useCallback(() => {
    setProgramItems((prev) => [...prev, { programId: null, enrollment: null, cantidadesState: null, monthState: null }]);
  }, []);
  const removeItem = React.useCallback((idx) => {
    setProgramItems((prev) => prev.filter((_, i) => i !== idx));
  }, []);
  const isSemesterBased =
    currentProgram?.program_type?.is_semester_based === true ||
    currentProgramType?.is_semester_based === true;
  const hasGraduationFee =
    currentProgram?.program_type?.has_graduation_fee === true ||
    currentProgramType?.has_graduation_fee === true;
  const { user } = useAuth();

  const id_est = params.id;

  React.useEffect(() => {
    const getStudentPrograms = async () => {
      const response = await xhr(`/students/${id_est}/programs`);
      const currenciesResponse = await xhr(`/currencies`);
      const getAffiliates = await xhr(`/affiliates?pagination[limit]=-1&populate=user`);
      setAffiliates(
        getAffiliates.data.data.map((el) => ({
          value: el.id,
          label: `${el.user?.first_name} ${el.user?.last_name}`,
        }))
      );
      setCurrencies(
        currenciesResponse.data.data.map((el) => ({
          value: el.id,
          label: el.name,
        }))
      );

      setPrograms(response.data);
    };

    getStudentPrograms();
  }, []);
  React.useEffect(() => {
    const getSubjectEnrollments = async () => {
      const response = await xhr(
        `/subject-enrollments?filters[student][id][$eq]=${id_est}&filters[subject][${currentProgram.program_type.type.replace(
          '-',
          '_'
        )}][id][$eq]=${currentProgram.id}&pagination[limit]=-1&populate=deep,2`
      );
      const filterIsTrial = response.data.data.filter((e) => e.is_trial !== true);
      setSubjectsEnrollments(filterIsTrial.map((el) => el.subject.id));
    };
    if (currentProgram) {
      getSubjectEnrollments();
    }
  }, [currentProgram]);

  const [productsFetching, setProductsFetching] = React.useState('');
  const [loading, setLoading] = React.useState(false);
  const [monthStudent, setMonthStudent] = React.useState([]);
  const [monthState, setMonthState] = React.useState(null);
  const [isPromo, setIsPromo] = React.useState(false);
  const [dateFilter, setDateFilter] = React.useState(null);
  const [amount, setAmount] = React.useState(0);
  const [conceptList, setConceptList] = React.useState([]);
  const [file, setFile] = React.useState(null);

  const refModal = React.useRef();
  const inputEl = React.useRef(null);
  const toasts = useToast();

  const handleDateChange = (date) => {
    setDateFilter(date);
  };

  const handleConcept = (event) => {
    setConcept(event);
    setAmount(0);
  };

  const handleProgram = async (value, currency) => {
    try {
      const filterProgram = programs.filter((program) => program.program_type?.type === currentProgramType.type);

      setProductsFetching('subjects');
      const program = filterProgram.find((el) => el.id === Number(value));
      const response = await xhr(`/subjects?filters[${program.program_type.type}][id][$eq]=${program.id}`);
      setSubjects(response.data.data);
      setCurrentProgram(program);
    } catch (error) {
    } finally {
      setProductsFetching('');
    }
  };

  const handleProgramType = async (value, currency) => {
    try {
      setProductsFetching('other_payments');

      const programType = props.programTypes.find((el) => Number(el.id) === Number(value));

      let response;

      if (programType.type === 'course' && currentProgram) {
        response = await xhr(`/other-payments?filters[course][id][$eq]=${currentProgram.id}`);
      } else {
        response = await xhr(`/other-payments?filters[program_type][id][$eq]=${value}`);
      }

      const otherPaymentsWithPrice = await Promise.all(
        response.data.data.map(async (el) => {
          const priceResponse = await xhr(
            `/other-payment-prices?filters[other_payment][id][$eq]=${el.id}&filters[currency][id][$eq]=${currency}`
          );

          return { ...el, price: priceResponse.data.data[0] };
        })
      );

      setOtherPayments(otherPaymentsWithPrice);
      setCurrentProgramType(programType);
    } catch (error) {
    } finally {
      setProductsFetching('');
    }
  };

  useEffect(() => {
    (async () => {
      setFetchingEnrollment(true);
      if (currentProgram && currentProgramType?.id) {
        const currentEnrollment = await xhr(
          `/${currentProgramType.type.replace('_', '-')}-enrollments?filters[student][id][$eq]=${id_est}&filters[${currentProgramType.type
          }][id][$eq]=${currentProgram.id}&filters[${currentProgramType.type}][program_type][id][$eq]=${currentProgramType.id
          }&populate=${currentProgramType.type}&populate=semester&sort[0]=updatedAt:desc`
        );

        setCurrentEnrollment(currentEnrollment.data.data.length > 0 ? currentEnrollment.data.data[0] : false);
        setFetchingEnrollment(false);
      }
    })();
  }, [currentProgram, currentProgramType]);

  useEffect(() => {
    if (months.length >= 1) setMonthsError(false);
  }, [months]);

  const handleCheck = (item, checked) => {
    let newConceptList;

    if (checked) {
      newConceptList = [...conceptList, item];
    } else {
      newConceptList = conceptList.filter((el) => el.id !== item.id);
    }

    const value = newConceptList.reduce((acc, current) => {
      return Number(acc) + Number(current.price ? current.price.value : 0);
    }, 0);

    setAmount(value);
    setConceptList(newConceptList);
  };

  const handleFileInput = (event) => {
    let currrentFile = event.target.files[0];
    if (!currrentFile) return false;

    setFile(currrentFile);
  };

  const handlePayment = async (values, action) => {
    try {
      if (!dateFilter || !values.method || !values.currency || !concept || !values.state || !amount)
        return window.alert('Debes completar los campos requeridos *');

      const detailRequired = concept === 'other_payments' && currentProgramType?.type && currentProgramType.type !== 'course';
      // Validar cada ítem del multi-programa.
      const activeItems = programItems.filter((it) => it.programId);
      if (detailRequired && activeItems.length === 0) {
        return window.alert('Selecciona al menos un programa *');
      }
      if (detailRequired) {
        for (let i = 0; i < activeItems.length; i++) {
          const it = activeItems[i];
          const p = programs.find((pr) => Number(pr.id) === Number(it.programId));
          const semSit = p?.program_type?.is_semester_based === true;
          if (semSit) {
            if (!it.enrollment?.id) {
              return window.alert(`Programa ${i + 1}: el estudiante no tiene matrícula activa en este programa`);
            }
            if (!it.cantidadesState?.skipOrdinals && !(it.cantidadesState?.ordinals?.length > 0)) {
              setCantidadesError(true);
              return window.alert(`Programa ${i + 1}: debes seleccionar al menos 1 materia *`);
            }
          } else {
            // Anualizado: valida meses del monthState de ese ítem.
            const monthCount = it.monthState?.months?.length ?? 0;
            if (monthCount === 0) {
              setMonthsError(true);
              return window.alert(`Programa ${i + 1}: debes seleccionar al menos 1 mes *`);
            }
          }
        }
        setCantidadesError(false);
        setMonthsError(false);
      }

      if (concept === 'subjects' && !conceptList.length) return window.alert('Debes agregar una materia');
      if (
        currentProgram?.slug !== 'academia-de-ingles' &&
        currentProgram?.slug !== 'curso-preicfes-saber-11-intensivo'
      ) {
        if (concept === 'other_payments' && !conceptList.length) return window.alert('Debes agregar un otro pago');
      }

      setLoading(true);

      const conceptListIds = conceptList.map((el) => el.id);
      const items = detailRequired
        ? activeItems
        : [currentProgram ? { programId: currentProgram.id } : programItems[0]];
      if (!items.length) {
        setLoading(false);
        return window.alert('No hay programa seleccionado');
      }

      // Multi-programa: UN solo POST /payments/ con el amount total y N puts a
      // manual-link (uno por matrícula), así queda 1 sola fila en /pagos-facturas
      // pero cartera ve la matrícula cubierta en cada programa.
      // El pago "primario" toma el programa/enrollment del PRIMER item, para
      // compat con los campos legacy (payment.grade_enrollment, program_type, etc).
      const primary = items[0];
      const primaryProgram = programs.find((pr) => Number(pr.id) === Number(primary.programId));
      if (!primaryProgram) {
        setLoading(false);
        return window.alert('Programa no encontrado');
      }
      const primaryPtType = primaryProgram.program_type.type;

      let data = {
        student: id_est,
        status: 'approved',
        amount,
        promo: isPromo,
        payment_date: dayjs(dateFilter).format('YYYY-MM-DD hh:mm'),
        type: concept,
        method: values.method,
        currency: values.currency,
        description,
        program_type: primaryProgram.program_type.id,
        [primaryPtType.replace('-', '_')]: primaryProgram.id,
        state: values.state,
        school: user?.school?.id || null,
        id_payment: values.id_payment,
        payment_cel: values.payment_cel,
      };
      if (primary.enrollment?.id) data[`${primaryPtType.replace('-', '_')}_enrollment`] = primary.enrollment.id;
      if (values.adviser) data.adviser = values.adviser;
      if (values.affiliate) data.affiliate = values.affiliate;
      if (concept === 'subjects') {
        data[primaryPtType] = primaryProgram.id;
        data.subjects = conceptListIds;
      }
      if (concept === 'other_payments') data.other_payments = conceptListIds;

      const response = await xhr.post(`/payments/`, { data });
      const newPaymentId = response.data.data.id;

      for (let i = 0; i < items.length; i++) {
        const it = items[i];
        const p = programs.find((pr) => Number(pr.id) === Number(it.programId));
        if (!p) continue;
        const ptType = p.program_type.type;
        const isSemBased = p.program_type.is_semester_based === true;

        if (isSemBased && it.enrollment?.id && it.cantidadesState) {
          try {
            await xhr.put('/payments/manual-link', {
              data: {
                paymentId: newPaymentId,
                enrollmentType: ptType,
                enrollmentId: it.enrollment.id,
                ...(it.cantidadesState.skipOrdinals
                  ? { skipOrdinals: true }
                  : { paidSubjectNumbers: it.cantidadesState.ordinals }),
              },
            });
          } catch (err) {
            console.error('manual-link:', err);
            toasts({
              title: `Programa ${i + 1}: el pago se creó pero no se guardaron las materias.`,
              status: 'warning', position: 'bottom',
            });
          }
          if (it.cantidadesState.graduationFeePaid !== undefined) {
            await xhr.put(`/${ptType.replace('_', '-')}-enrollments/${it.enrollment.id}`, {
              data: { graduation_fee_paid: !!it.cantidadesState.graduationFeePaid },
            });
          }
        }

        if (!isSemBased && ptType !== 'course' && it.monthState?.enrollmentId && (it.monthState.months?.length ?? 0) > 0) {
          if (it.monthState.isSemesterBased && !it.monthState.semesterId) {
            window.alert(`Programa ${i + 1}: selecciona un semestre — no se guardaron los meses.`);
          } else {
            await saveMonths({
              studentId: id_est,
              enrollmentType: it.monthState.enrollmentType,
              enrollmentId: it.monthState.enrollmentId,
              semesterId: it.monthState.semesterId ?? null,
              months: it.monthState.months.map((m) => (typeof m === 'object' ? m.id : m)),
              on_day: it.monthState.onDay,
              promoteOrphan: !!it.monthState.promoteOrphan,
            });
          }
        }

        if (!isSemBased && it.monthState?.graduationFeePaid !== undefined && it.monthState?.enrollmentId && it.monthState?.enrollmentType) {
          await xhr.put(`/${it.monthState.enrollmentType.replace('_', '-')}-enrollments/${it.monthState.enrollmentId}`, {
            data: { graduation_fee_paid: !!it.monthState.graduationFeePaid },
          });
        }
      }

      const responsePopulate = await xhr(`/payments/${newPaymentId}?populate=deep,3`);
      const createdPayment = responsePopulate.data.data;
      setPayments([createdPayment, ...payments]);

      // Imagen del pago: se sube al pago único.
      if (file) {
        const formData = new FormData();
        formData.append('files', file);
        formData.append('ref', 'api::payment.payment');
        formData.append('refId', createdPayment.id);
        formData.append('field', 'image');
        await xhr('/upload', {
          method: 'post',
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }
      mutate([createdPayment, ...paymentsData]);

      action.resetForm();

      inputEl.current.value = '';
      setAmount(0);
      setDateFilter(null);
      setDescription('');
      setSubjects([]);
      setIsOpen(false);
      toasts({
        title: 'El pago se creo correctamente!',
        accent: 'bottom',
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box width="100%" marginTop="15px" marginBottom="md">
      <Formik
        initialValues={{
          amount: '',
          method: '',
          state: '',
          affiliate: '',
          adviser: '',
          currency: '',
          description: '',
          concept: '',
          id_payment: '',
          payment_cel: '',
        }}
        onSubmit={handlePayment}
      >
        {(formData) => {
          const conceptListIds = conceptList.map((el) => el.id);

          return (
            <Form>
              <Box marginY="5px">Fecha Pago *</Box>
              <DatePicker date={dateFilter} placeholder="Fecha del pago" onChange={handleDateChange} />
              <Box marginY="5px">ID Pago</Box>
              <Field
                name="id_payment"
                type="text"
                placeholder="ID del pago"
                className={`${globals.input} ${globals.nombres}`}
              />

              <Box marginY="5px">Celular del Pago</Box>
              <Field
                name="payment_cel"
                type="text"
                placeholder="Celular asociado al pago"
                className={`${globals.input} ${globals.nombres}`}
              />
              <Box marginY="5px">Medio de Pago *</Box>
              <Field
                name="method"
                as="select"
                placeholder="Medio de Pago"
                color="black"
                className={`${globals.input} ${globals.nombres}`}
              >
                <option value=""> Seleccione </option>
                <option value="payu"> PayU </option>
                <option value="bancolombia"> Bancolombia </option>
                <option value="efecty"> Efecty </option>
                <option value="wompi"> Wompi </option>
                <option value="wompi_2"> Wompi 2 </option>
                <option value="sistecredito"> Sistecredito </option>
                <option value="sede_bucaramanga"> Sede Bucaramanga </option>
                <option value="sede_turbaco"> Sede Turbaco </option>
                <option value="sede_arjona"> Sede Arjona </option>
                <option value="western_union"> Western Union </option>
                <option value="stripe"> Stripe </option>
                <option value="paypal"> Paypal </option>
                <option value="addi"> Addi </option>
                <option value="bitcoins"> Bitcoins </option>
              </Field>
              <ErrorMessage name={'method'}>
                {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
              </ErrorMessage>

              <Box marginY="5px">Estado *</Box>
              <Field
                name="state"
                as="select"
                placeholder="Asesor"
                color="black"
                className={`${globals.input} ${globals.nombres}`}
              >
                <option value=""> Seleccione </option>
                {user?.school ? (
                  ''
                ) : (
                  <>
                    <option value="admisiones"> Admisiones </option>
                    <option value="cobranza"> Cobranza </option>
                  </>
                )}

                <option value="recurrente"> Recurrente </option>
              </Field>
              <ErrorMessage name={'state'}>
                {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
              </ErrorMessage>

              {formData.values.state === 'admisiones' && (
                <>
                  <Box marginY="5px">Asesor</Box>
                  <Field
                    name="adviser"
                    as="select"
                    placeholder="Asesor"
                    color="black"
                    className={`${globals.input} ${globals.nombres}`}
                  >
                    <option value=""> Seleccione </option>
                    {advisers.map((el) => (
                      <option value={el.value}> {el.label} </option>
                    ))}
                  </Field>

                  <Box marginY="5px">Afiliado</Box>
                  <Field
                    name="affiliate"
                    as="select"
                    placeholder="Afiliado"
                    color="black"
                    className={`${globals.input} ${globals.nombres}`}
                  >
                    <option value=""> Seleccione </option>
                    {affiliates.map((el) => (
                      <option value={el.value}> {el.label} </option>
                    ))}
                  </Field>
                </>
              )}

              <Box marginY="5px">Moneda *</Box>
              <Field
                name="currency"
                as="select"
                placeholder="Moneda"
                color="black"
                className={`${globals.input} ${globals.nombres}`}
              >
                <option value={''}>Seleccione</option>
                {currencies.map((el) => {
                  return (
                    <option key={el.label} value={el.value}>
                      {el.label}
                    </option>
                  );
                })}
              </Field>
              <ErrorMessage name={'currency'}>
                {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
              </ErrorMessage>

              {formData.values.currency && (
                <>
                  <Box marginY="5px">Concepto *</Box>
                  <Select
                    name="concept"
                    color="black"
                    className={`${globals.input} ${globals.nombres}`}
                    onChange={(event) => handleConcept(event.target.value)}
                  >
                    <option value={''}>Seleccione</option>
                    <option value={'other_payments'}>Pagos</option>
                    <option value={'others'}>Otros</option>
                  </Select>
                  <ErrorMessage name={'concept'}>
                    {(msg) => <div style={{ color: 'red', fontSize: 13 }}>{msg}</div>}
                  </ErrorMessage>

                  {concept === 'other_payments' && (
                    <>
                      <Box marginY="5px">Tipo de Programa *</Box>
                      <Select
                        name="program_type"
                        variant="filled"
                        value={formData.values.program_type}
                        backgroundColor="transparent"
                        border="1px solid #e2dcdc!important"
                        onChange={(event) => handleProgramType(event.target.value, formData.values.currency)}
                      >
                        <option value={''}>Seleccione</option>
                        {props.programTypes?.map((el) => (
                          <option value={el.id}>{el.name}</option>
                        ))}
                      </Select>
                    </>
                  )}

                  {concept && Object.keys(currentProgramType).length > 0 && (
                    <Box marginY="8px">
                      {programItems.map((it, i) => (
                        <PaymentProgramItem
                          key={`ppi-${i}`}
                          index={i}
                          studentId={id_est}
                          programs={programs}
                          currentProgramType={currentProgramType}
                          concept={concept}
                          value={it}
                          onChange={(patch) => {
                            setItem(i, patch);
                            // Sincronizar el primer item con los estados globales para no romper el resto del form.
                            if (i === 0) {
                              if (patch.programId !== undefined) {
                                const p = programs.find((pr) => Number(pr.id) === Number(patch.programId));
                                if (p) handleProgram(p.id, formData.values.currency);
                                else setCurrentProgram('');
                              }
                              if (patch.enrollment !== undefined) setCurrentEnrollment(patch.enrollment || undefined);
                              if (patch.cantidadesState !== undefined) setCantidadesState(patch.cantidadesState);
                              if (patch.monthState !== undefined) setMonthState(patch.monthState);
                            }
                          }}
                          onRemove={() => removeItem(i)}
                          canRemove={programItems.length > 1 && i > 0}
                          isOpenInitial
                          paymentDate={dateFilter}
                        />
                      ))}
                      {concept === 'other_payments' && currentProgramType.type !== 'course' && (
                        <Button
                          variant="outline"
                          size="sm"
                          onClick={addItem}
                          marginTop="0"
                          marginBottom="16px"
                        >
                          + Agregar otro programa
                        </Button>
                      )}
                    </Box>
                  )}

                  {concept === 'subjects' && formData.values.program && (
                    <>
                      <Box marginBottom="md" border="1px solid" borderColor="white900">
                        <Box
                          backgroundColor="primary100"
                          color="primary700"
                          fontWeight="500"
                          padding="8"
                          paddingX="15px"
                        >
                          ¿Qué materias paga el estudiante?
                        </Box>

                        {productsFetching === 'subjects' ? (
                          <Flex justifyContent="center" paddingY="lg">
                            <Spinner />
                          </Flex>
                        ) : (
                          <Box display="grid" gridTemplateColumns="1fr 1fr" padding="15px" gridGap="12px">
                            {subjects.map((el) => {
                              const isEnrolled = subjectEnrollments.includes(el.id);

                              return (
                                <Flex>
                                  <Checkbox
                                    checked={isEnrolled || conceptListIds.includes(el.id)}
                                    isDisabled={isEnrolled}
                                    textDecoration={isEnrolled && 'line-through'}
                                    cursor={isEnrolled ? 'not-allowed' : 'pointer'}
                                    label={el.name}
                                    onChange={(event) => handleCheck(el, event.target.checked)}
                                  />
                                </Flex>
                              );
                            })}

                            {!subjects.length && <Box textAlign="center">No se encontraron materias</Box>}
                          </Box>
                        )}
                      </Box>
                    </>
                  )}

                  {concept === 'other_payments' && Object.keys(currentProgramType).length > 0 && currentProgram && (
                    <>
                      {currentProgramType.type === 'course' ? (
                        ''
                      ) : (
                        <Box
                          marginBottom="20px"
                          marginTop="10px"
                          border="1px solid #e2e8f0"
                          borderColor="white900"
                          borderTopRadius="5px"
                        >
                          <Box
                            color="purple.700"
                            fontWeight="500"
                            paddingY="8px"
                            paddingX="15px"
                            backgroundColor="purple.200"
                            borderTopRadius="5px"
                          >
                            ¿Qué otros pagos cancela el estudiante? *
                          </Box>

                          {productsFetching === 'other_payments' ? (
                            <Flex justifyContent="center" paddingY="lg">
                              <Spinner />
                            </Flex>
                          ) : (
                            <Box display="grid" gridTemplateColumns="1fr 1fr" padding="15px" gridGap="12px">
                              {otherPayments.map((el) => {
                                return (
                                  <Flex>
                                    <Checkbox
                                      defaultChecked={conceptListIds.includes(el.id) ? true : false}
                                      onChange={(event) => handleCheck(el, event.target.checked)}
                                    >
                                      {el.name}
                                    </Checkbox>
                                  </Flex>
                                );
                              })}

                              {!otherPayments.length && <Box textAlign="center">No se encontraron otros pagos</Box>}
                            </Box>
                          )}
                        </Box>
                      )}

                    </>
                  )}

                  <Box for="amount">Monto *</Box>
                  <Field
                    value={amount}
                    marginTop="20px"
                    type="number"
                    label="Valor"
                    name="amount"
                    onChange={(event) => setAmount(event.target.value)}
                    className={`${globals.input} ${globals.nombres}`}
                  />
                </>
              )}

              <Checkbox
                checked={isPromo}
                onChange={(e) => setIsPromo(e.target.checked)}
                _focus={{ boxShadow: 'transparent' }}
                my="10px"
              >
                Aplica Promoción
              </Checkbox>

              <br />

              <Box for="description">Descripción</Box>

              <Textarea onChange={(event) => setDescription(event.target.value)} />

              <br />
              <Box for="amount">Imagen del Pago</Box>
              <Input type="file" ref={inputEl} onChange={handleFileInput} />
              <br />

              <Flex alignItems="center">
                <Button
                  type="submit"
                  colorScheme="messenger"
                  backgroundColor="#574feb"
                  marginY="15px"
                  width="140px"
                  isLoading={loading}
                  isDisabled={loading}
                >
                  Guardar
                </Button>
              </Flex>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
}